module.exports = __webpack_public_path__ + "img/graduated-1-min.90d3c28d.png";